<template>
  <div class="row bg-white">
    <div class="col-12">
      <c-search-box>
        <template slot="search">
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-plant 
              class="none-bottom" 
              type="search" 
              name="plantCd" 
              v-model="searchParam.plantCd"   />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <!-- 기간 -->
            <c-datepicker
              :range="true"
              label="LBLPERIOD"
              type="month"
              name="period"
              defaultStart="-12M"
              defaultEnd="1M"
              v-model="period"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <!-- 발생부서 -->
            <c-dept
              type="search"
              :isFirstValue="false"
              name="occurrenceDeptCd"
              label="LBL0002302"
              v-model="searchParam.occurrenceDeptCd"
            ></c-dept>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-text
              type="number"
              suffix="년 이상"
              name="longevity"
              label="근속년수"
              v-model="searchParam.longevity"
            ></c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-right q-mt-md">
            <c-btn label="검색" icon="search" @btnClicked="plantChange" />
          </div>
        </template>
      </c-search-box>
      <div class="row">
        <div class="col-6">
          <apexchart 
            class="accidentChart"
            ref="yearOcuurChart" 
            height="350" 
            type="bar"
            :options="yearOcuurChart.chartOptions" 
            :series="yearOcuurChart.series"></apexchart>
        </div>
        <div class="col-6">
          <apexchart 
            class="accidentChart"
            ref="seasonOcuurChart" 
            height="350" 
            type="bar"
            :options="seasonOcuurChart.chartOptions" 
            :series="seasonOcuurChart.series"></apexchart>
        </div>
        <div class="col-12">
          <apexchart 
            class="accidentChart"
            ref="hourOcuurChart" 
            height="350" 
            type="line"
            :options="hourOcuurChart.chartOptions" 
            :series="hourOcuurChart.series"></apexchart>
        </div>
        <div class="col-6">
          <apexchart 
            class="accidentChart"
            ref="kindOcuurChart1" 
            height="350" 
            type="bar"
            :options="kindOcuurChart1.chartOptions" 
            :series="kindOcuurChart1.series"></apexchart>
        </div>
        <div class="col-6">
          <apexchart 
            class="accidentChart"
            ref="ageOcuurChart" 
            height="350" 
            type="line"
            :options="ageOcuurChart.chartOptions" 
            :series="ageOcuurChart.series"></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import selectConfig from '@/js/selectConfig';
import VueApexCharts from "vue-apexcharts";
export default {
  name: 'accident-status',
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      fullscreen: false,
      searchParam: {
        plantCd: '',
        accidentTypeCd: null,
        longevity: 0,
      },
      yearOcuurChart: {
        chartOptions: {
          chart: {
            type: 'bar',
          },
          title: {
            text: '년도별 안전사고 발생 건 수'
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '60%',
              endingShape: 'rounded',
              distributed: true
            },
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val;
            },
            offsetY: 0,
            style: {
              fontSize: '12px',
              colors: ["#fcfafa"]
            }
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          colors: ['#008FFB','#00E396','#FEB019','#FF4560','#775DD0','#3F51B5','#03A9F4','#4CAF50','#F9CE1D','#FF9800','#A300D6','#5653FE','#1B998B','#F86624','#13D8AA'],
          labels: {
            style: {
              colors: ['#008FFB','#00E396','#FEB019','#FF4560','#775DD0','#3F51B5','#03A9F4','#4CAF50','#F9CE1D','#FF9800','#A300D6','#5653FE','#1B998B','#F86624','#13D8AA'],
              fontSize: '12px'
            }
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: '건'
            }
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return  + val + " 건"
              }
            }
          }
        },
        series: [],
        chartWidth: '80%',
      },
      hourOcuurChart: {
        chartOptions: {
          title: {
            text: '시간대별 안전사고 발생 건 수'
          },
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false
            },
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val;
            },
            offsetY: 0,
            style: {
              fontSize: '12px',
              colors: ["#304758"]
            }
          },
          stroke: {
            width: [5, 7, 5],
            curve: 'straight',
            dashArray: [0, 8, 5]
          },
          xaxis: {
            categories: ['00시', '01시', '02시', '03시', '04시', '05시', '06시', '07시', '08시','09시','10시','11시','12시',
            '13시','14시','15시','16시','17시','18시','19시','20시','21시','22시','23시'],
          },
          yaxis: {
            title: {
              text: '건'
            }
          },
          fill: {
            opacity: 1
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          markers: {
            size: 0,
            hover: {
              sizeOffset: 6
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return   val + " 건"
              }
            }
          }
        },
        series: [
          {
            name: '시간',
            //24개
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ],
        chartWidth: '80%',
      },
      seasonOcuurChart: {
        chartOptions: {
          chart: {
            type: 'bar',
          },
          title: {
            text: '계절별 안전사고 발생 건 수'
          },
          colors: ['#f5a2f5', '#1cfc50', '#ffa35c','#ff5465',],
          labels: {
            style: {
              colors: ['#f5a2f5', '#1cfc50', '#ffa35c','#ff5465',],
              fontSize: '12px'
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '60%',
              endingShape: 'rounded',
              distributed: true
            },
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val;
            },
            offsetY: 0,
            style: {
              fontSize: '12px',
              colors: ["#fcfafa"]
            }
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: [ '봄', '여름', '가을', '겨울'],
          },
          yaxis: {
            title: {
              text: '건'
            }
          },
          fill: {
            opacity: 1
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return  + val + " 건"
              }
            }
          }
        },
        series: [
          {
            name: '발생 건 수',
            data: [0,0,0,0]
          }
        ],
        chartWidth: '80%',
      },
      kindOcuurChart1: {
        chartOptions: {
          chart: {
            type: 'bar',
          },
          title: {
            text: '재해유형별 발생 건 수'
          },
          colors: ['#775DD0','#1B998B','#F86624','#3F51B5','#03A9F4','#4CAF50','#F9CE1D','#FF9800','#A300D6','#5653FE','#13D8AA'],
          labels: {
            style: {
              colors: ['#775DD0','#1B998B','#F86624','#3F51B5','#03A9F4','#4CAF50','#F9CE1D','#FF9800','#A300D6','#5653FE','#13D8AA'],
              fontSize: '12px'
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '60%',
              endingShape: 'rounded',
              distributed: true
            },
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val;
            },
            offsetY: 0,
            style: {
              fontSize: '12px',
              colors: ["#fcfafa"]
            }
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: undefined
            }
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return  val + " 건"
              }
            }
          },
          legend: {
            position: 'top',
            horizontalAlign: 'center',
          }
        },
        series: [
          
        ],
        //  21, 12, 12, 15, 21, 12],
        chartWidth: '100%',
      },
      ageOcuurChart: {
        chartOptions: {
          title: {
            text: '연령대별 발생 건 수'
          },
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false
            },
          },
          colors: ['#f7f134', '#6bffe1', '#ffa35c','#ff5465',],
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val;
            },
            offsetY: 0,
            style: {
              fontSize: '12px',
              colors: ["#304758"]
            }
          },
          stroke: {
            width: [5, 7, 5],
            curve: 'straight',
            dashArray: [0, 8, 5]
          },
          xaxis: {
            categories: ['20대 미만', '20대', '30대', '40대', '50대', '60대 이상'],
          },
          yaxis: {
            title: {
              text: '건'
            }
          },
          fill: {
            opacity: 1
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          markers: {
            size: 0,
            hover: {
              sizeOffset: 6
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return   val + " 건"
              }
            }
          }
        },
        series: [
          {
            name: '시간',
            //24개
            data: [0, 0, 0, 0, 0, 0]
          }
        ],
        chartWidth: '80%',
      },
      period: [],
      options: [],
      selectProcessCd: '',
      editable: true,
      searchUrl: '',
      count: 0,
      yearUrl: '',
      hourUrl: '',
      seasonUrl: '',
      kindUrl: '',
      ageUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.yearUrl = selectConfig.sop.iim.accident.status.year.url;
      this.hourUrl = selectConfig.sop.iim.accident.status.hour.url;
      this.seasonUrl = selectConfig.sop.iim.accident.status.season.url;
      this.kindUrl1 = selectConfig.sop.iim.accident.status.kind1.url;
      this.kindUrl2 = selectConfig.sop.iim.accident.status.kind2.url;
      this.ageUrl = selectConfig.sop.iim.accident.status.age.url;
      // 년도 설정
      // let years = [];
      // for (let i = 0; i < 5; i++) {
      //   years.splice(0, 0, this.$comm.getPrevYear(i));
      // }
      // this.yearOcuurChart.chartOptions.xaxis.categories = years;

      // url setting
      this.getYearList();
      this.getHourList();
      this.getSeasonList();
      this.getKindList1();
      this.getAgeList();

    },
    getYearList() {
      if(this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.$http.url = this.yearUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.yearOcuurChart.chartOptions.xaxis.categories = this.$_.map(_result.data, 'occurYear');
        this.yearOcuurChart.series = [{data: this.$_.map(_result.data, 'yearCount'), name: '발생 건 수'}];
      
        this.$refs['yearOcuurChart'].refresh();
        this.yearOcuurChart.chartWidth = '90%';
      },);
    },
    getHourList() {
      this.hourOcuurChart.series[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.$http.url = this.hourUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.$_.forEach(_result.data, _item => {
        // 년도에 따른 idx를 구하여 series.data의 위치 통일
          let idx = this.hourOcuurChart.chartOptions.xaxis.categories.indexOf(_item.occurTime)

          this.hourOcuurChart.series[0].data[idx] = _item.timeCount
        })
        this.hourOcuurChart.chartWidth = '90%';
        this.$refs['hourOcuurChart'].refresh();
      },);
    },
    getSeasonList() {
      this.$http.url = this.seasonUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        if (_result.data && _result.data.length > 0) {
          this.$_.forEach(_result.data, _item => {
          // 년도에 따른 idx를 구하여 series.data의 위치 통일
            let idx = 0
            if (_item.occurMonth === '12' || _item.occurMonth === '01' || _item.occurMonth === '02') {
              idx = 3;
            } else if (_item.occurMonth === '03' || _item.occurMonth === '04' || _item.occurMonth === '05') {
              idx = 0;
            } else if (_item.occurMonth === '06' || _item.occurMonth === '07' || _item.occurMonth === '08') {
              idx = 1;
            } else if (_item.occurMonth === '09' || _item.occurMonth === '10' || _item.occurMonth === '11') {
              idx = 2;
            }
            this.seasonOcuurChart.series[0].data[idx] += Number(_item.monthCount)
          })
        } else {
          this.seasonOcuurChart.series = [
            {
              name: '발생 건 수',
              data: [0,0,0,0]
            }
          ]
        }

        this.$refs['seasonOcuurChart'].refresh();
        this.seasonOcuurChart.chartWidth = '90%';
      },);
    },
    getKindList1() {
      this.$http.url = this.kindUrl1;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.kindOcuurChart1.series = [];
        this.kindOcuurChart1.chartOptions.xaxis.categories = [];
        let _data = [];
        this.$_.forEach(_result.data, _item => {
          this.$_.forEach(_item.accidentKindName.split(','), __item => {
            let idx = this.kindOcuurChart1.chartOptions.xaxis.categories.indexOf(__item)
            if (idx === -1) {
              this.kindOcuurChart1.chartOptions.xaxis.categories.push(__item)
              _data.push(Number(_item.kindCount))
            } else {
              _data[idx] = Number(_data[idx]) + Number(_item.kindCount);
            }
          })
        })
        this.kindOcuurChart1.series = [{data: _data, name: '발생 건 수'}] 
        this.$refs['kindOcuurChart1'].refresh();
        this.kindOcuurChart1.chartWidth = '90%';
      },);
    },
    getAgeList() {
      this.$http.url = this.ageUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        if (_result.data && _result.data.length > 0 && _result.data[0]) {
          this.ageOcuurChart.series = [
            {
              data: [_result.data[0].tenAge,_result.data[0].twentyAge, _result.data[0].thirtyAge, 
                    _result.data[0].fourtyAge, _result.data[0].fiftyAge, _result.data[0].sixtyAge
              ],
              name: '발생 건 수'
            }
          ];
        } else {
          this.ageOcuurChart.series = [
            {
              data: [0,0,0,0,0,0],
              name: '발생 건 수'
            }
          ]
        }
        
        this.$refs['ageOcuurChart'].refresh();
        this.ageOcuurChart.chartWidth = '90%';
      },);
    },
    plantChange() {
      if(this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }

      if (!this.searchParam.longevity) this.searchParam.longevity = 0;
      
      this.getYearList();
      this.getHourList();
      this.getSeasonList();
      this.getKindList1();
      this.getAgeList();
    },
  }
};
</script>
<style lang="sass">
.el-cascader-menu__wrap
  height: calc(var(--cascader-height-var)) !important
.dashborad
  .customCardbody
    padding: 0px !important
    margin: 0px !important

// .el-cascader-node
//   padding: 0 30px 0 5px !important
// .el-cascader-menu
//   min-width: auto
// .el-cascader-node__label
//   padding: 0px !important
.grid-menu [class*=col-]
  border-width: 0 !important
  // border-right: #dee2e6 solid 0 !important
  // border-bottom: #dee2e6 solid 1px !important
  padding: 0px !important
.widget-yearOcuurChart
  padding: 5px !important
.widget-yearOcuurChart .widget-numbers
  margin: 12px !important

.none-bottom
  .q-field--with-bottom
    padding-bottom: 0px !important

.app-main__inner .riskassess-dashboard
  .row [class*=col-]
    padding: 0px !important

.accidentChart
  padding: 20px !important
  border: 1px solid #dee2e6
  border-top: 3px solid #dee2e6
</style>
<style scoped>
.blinking {
  -webkit-animation:blink 1s ease-in-out infinite alternate;
  -moz-animation:blink 1s ease-in-out infinite alternate;
  animation:blink 1s ease-in-out infinite alternate;
}
@-webkit-keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
@-moz-keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
@keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
</style>